<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex">
      <div class="navbar-brand-box">
        <a routerLink="/" class="logo logo-dark">
          <span class="logo-sm">
            <img src="assets/images/logo.svg" alt="" height="22">
          </span>
          <span class="logo-lg">
            <img src="assets/images/logo-dark.png" alt="" height="17">
          </span>
        </a>

        <a routerLink="/" class="logo logo-light">
          <span class="logo-sm">
            <img src="assets/images/logo-light.svg" alt="" height="22">
          </span>
          <span class="logo-lg">
            <img src="assets/images/logo-light.png" alt="" height="19">
          </span>
        </a>
      </div>

      <button type="button" class="btn btn-sm px-3 font-size-16 d-lg-none header-item" (click)="toggleMenubar()">
        <i class="fa fa-fw fa-bars"></i>
      </button>

      <form class="app-search d-none d-xl-block">
        <div class="position-relative">
          <input type="text" class="form-control" placeholder="{{'HEADER.SEARCH' | translate}}">
          <span class="bx bx-search-alt"></span>
        </div>
      </form>

      <div class="dropdown dropdown-mega d-none d-lg-block me-2" dropdown>
        <button type="button" class="btn header-item" dropdownToggle>
          {{ 'HEADER.MEGA_MENU' | translate}}
          <i class="mdi mdi-chevron-down"></i>
        </button>
        <div class="dropdown-menu dropdown-megamenu" *dropdownMenu>
          <div class="row">
            <div class="col-sm-8">

              <div class="row">
                <div class="col-md-4">
                  <h5 class="font-size-14 mt-0">{{ 'HEADER.UI.TITLE' | translate}}</h5>
                  <ul class="list-unstyled megamenu-list">
                    <li>
                      <a href="javascript:void(0);">{{ 'HEADER.UI.LIGHTBOX' | translate}}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{ 'HEADER.UI.RANGE_SLIDER' | translate}}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{ 'HEADER.UI.SWEET_ALERT' | translate}}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{ 'HEADER.UI.RATING' | translate}}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{ 'HEADER.UI.FORMS' | translate}}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{ 'HEADER.UI.TABLES' | translate}}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{ 'HEADER.UI.CHARTS' | translate}}</a>
                    </li>
                  </ul>
                </div>

                <div class="col-md-4">
                  <h5 class="font-size-14 mt-0">{{ 'HEADER.APPLICATIONS.TITLE' | translate}}</h5>
                  <ul class="list-unstyled megamenu-list">
                    <li>
                      <a href="javascript:void(0);">{{ 'HEADER.APPLICATIONS.ECOMMERCE' | translate}}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{ 'HEADER.APPLICATIONS.CALENDAR' | translate}}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{ 'HEADER.APPLICATIONS.EMAIL' | translate}}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{ 'HEADER.APPLICATIONS.PROJECTS' | translate}}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{ 'HEADER.APPLICATIONS.TASKS' | translate}}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{ 'HEADER.APPLICATIONS.CONTACTS' | translate}}</a>
                    </li>
                  </ul>
                </div>

                <div class="col-md-4">
                  <h5 class="font-size-14 mt-0">{{ 'HEADER.EXTRA_PAGES.TITLE' | translate}}</h5>
                  <ul class="list-unstyled megamenu-list">
                    <li>
                      <a href="javascript:void(0);">{{ 'HEADER.EXTRA_PAGES.LIGHT_SIDEBAR' | translate}}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{ 'HEADER.EXTRA_PAGES.COMPACT_SIDEBAR' | translate}}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{ 'HEADER.EXTRA_PAGES.HORIZONTAL_LAYOUT' | translate}}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{ 'HEADER.EXTRA_PAGES.MAINTENANCE' | translate}}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{ 'HEADER.EXTRA_PAGES.COMING SOON' | translate}}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{ 'HEADER.EXTRA_PAGES.TIMELINE' | translate}}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{ 'HEADER.EXTRA_PAGES.FAQ' | translate}}</a>
                    </li>

                  </ul>
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="row">
                <div class="col-sm-6">
                  <h5 class="font-size-14 mt-0">{{ 'HEADER.UI.TITLE' | translate}}</h5>
                  <ul class="list-unstyled megamenu-list">
                    <li>
                      <a href="javascript:void(0);">{{ 'HEADER.UI.LIGHTBOX' | translate}}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{ 'HEADER.UI.RANGE_SLIDER' | translate}}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{ 'HEADER.UI.SWEET_ALERT' | translate}}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{ 'HEADER.UI.RATING' | translate}}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{ 'HEADER.UI.FORMS' | translate}}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{ 'HEADER.UI.TABLES' | translate}}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{ 'HEADER.UI.CHARTS' | translate}}</a>
                    </li>
                  </ul>
                </div>

                <div class="col-sm-5">
                  <div>
                    <img src="assets/images/megamenu-img.png" alt="" class="img-fluid mx-auto d-block">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex">

      <div class="dropdown d-inline-block d-lg-none me-2" dropdown>
        <button type="button" class="btn header-item noti-icon" id="page-header-search-dropdown" dropdownToggle>
          <i class="mdi mdi-magnify"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" *dropdownMenu>

          <form class="p-3">
            <div class="m-0">
              <div class="input-group">
                <input type="text" class="form-control" placeholder="Search ..." aria-label="Recipient's username">
                <div class="input-group-append">
                  <button class="btn btn-primary" type="submit"><i class="mdi mdi-magnify"></i></button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="dropdown d-inline-block" dropdown>
        <button type="button" class="btn header-item" id="page-header-user-dropdown" dropdownToggle>
          @if (flagvalue !== undefined) {
          <img src="{{flagvalue}}" alt="Header Language" height="16">
          } <span class="ms-1">{{countryName}}</span>
          @if (flagvalue === undefined) {
          <img src="{{valueset()}}" alt="Header Language" height="16">
          }
          @if (flagvalue === undefined) {
          <span class="ms-1">English</span>
          }
        </button>
        <div class="dropdown-menu dropdown-menu-end" *dropdownMenu>
          @for (item of listLang(); track item) {
          <a href="javascript:void(0);" class="dropdown-item notify-item"
            (click)="setLanguage(item.text, item.lang, item.flag)" [ngClass]="{'active': cookieValue() === item.lang}">
            <img src="{{item.flag}}" alt="user-image" class="ms-1" height="12"> <span
              class="align-middle">{{item.text}}</span>
          </a>
          }
        </div>
      </div>

      <div class="dropdown d-none d-lg-inline-block me-1" dropdown>
        <button type="button" class="btn header-item noti-icon" dropdownToggle>
          <i class="bx bx-customize"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end" *dropdownMenu>
          <div class="px-lg-2">
            <div class="row no-gutters">
              <div class="col">
                <a class="dropdown-icon-item" href="javascript: void(0);">
                  <img src="assets/images/brands/github.png" alt="Github">
                  <span>GitHub</span>
                </a>
              </div>
              <div class="col">
                <a class="dropdown-icon-item" href="javascript: void(0);">
                  <img src="assets/images/brands/bitbucket.png" alt="bitbucket">
                  <span>Bitbucket</span>
                </a>
              </div>
              <div class="col">
                <a class="dropdown-icon-item" href="javascript: void(0);">
                  <img src="assets/images/brands/dribbble.png" alt="dribbble">
                  <span>Dribbble</span>
                </a>
              </div>
            </div>

            <div class="row no-gutters">
              <div class="col">
                <a class="dropdown-icon-item" href="javascript: void(0);">
                  <img src="assets/images/brands/dropbox.png" alt="dropbox">
                  <span>Dropbox</span>
                </a>
              </div>
              <div class="col">
                <a class="dropdown-icon-item" href="javascript: void(0);">
                  <img src="assets/images/brands/mail_chimp.png" alt="mail_chimp">
                  <span>Mail Chimp</span>
                </a>
              </div>
              <div class="col">
                <a class="dropdown-icon-item" href="javascript: void(0);">
                  <img src="assets/images/brands/slack.png" alt="slack">
                  <span>Slack</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="dropdown d-none d-lg-inline-block me-1">
        <button type="button" class="btn header-item noti-icon" data-toggle="fullscreen" (click)="fullscreen()">
          <i class="bx bx-fullscreen"></i>
        </button>
      </div>

      <div class="dropdown d-inline-block" dropdown>
        <button type="button" class="btn header-item noti-icon" id="page-header-notifications-dropdown" dropdownToggle>
          <i class="bx bx-bell bx-tada"></i>
          <span class="badge bg-danger rounded-pill">3</span>
        </button>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" *dropdownMenu
          aria-labelledby="page-header-notifications-dropdown">
          <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="m-0">{{ 'HEADER.NOTIFICATIONS.TITLE' | translate}} </h6>
              </div>
              <div class="col-auto">
                <a href="javascript: void(0);" class="small">{{ 'HEADER.NOTIFICATIONS.VIEW_ALL' | translate}}</a>
              </div>
            </div>
          </div>
          <ngx-simplebar style="position: relative; height: 230px;">
            <a href="javascript: void(0);" class="text-reset notification-item">
              <div class="media">
                <div class="avatar-xs me-3">
                  <span class="avatar-title bg-primary rounded-circle font-size-16">
                    <i class="bx bx-cart"></i>
                  </span>
                </div>
                <div class="media-body">
                  <h6 class="mt-0 mb-1">{{ 'HEADER.NOTIFICATIONS.FIRST.TITLE' | translate}}</h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">{{ 'HEADER.NOTIFICATIONS.FIRST.TEXT' | translate}}</p>
                    <p class="mb-0"><i class="mdi mdi-clock-outline"></i>
                      {{ 'HEADER.NOTIFICATIONS.FIRST.TIME' | translate}}</p>
                  </div>
                </div>
              </div>
            </a>
            <a href="javascript: void(0);" class="text-reset notification-item">
              <div class="media">
                <img src="assets/images/users/avatar-3.jpg" class="me-3 rounded-circle avatar-xs" alt="user-pic">
                <div class="media-body">
                  <h6 class="mt-0 mb-1">{{ 'HEADER.NOTIFICATIONS.SECOND.TITLE' | translate}}</h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">{{ 'HEADER.NOTIFICATIONS.SECOND.TEXT' | translate}}</p>
                    <p class="mb-0"><i class="mdi mdi-clock-outline"></i>{{ 'HEADER.NOTIFICATIONS.SECOND.TIME' |
                      translate}}</p>
                  </div>
                </div>
              </div>
            </a>
            <a href="javascript: void(0);" class="text-reset notification-item">
              <div class="media">
                <div class="avatar-xs me-3">
                  <span class="avatar-title bg-success rounded-circle font-size-16">
                    <i class="bx bx-badge-check"></i>
                  </span>
                </div>
                <div class="media-body">
                  <h6 class="mt-0 mb-1">{{ 'HEADER.NOTIFICATIONS.THIRD.TITLE' | translate}}</h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">{{ 'HEADER.NOTIFICATIONS.THIRD.TEXT' | translate}}</p>
                    <p class="mb-0"><i class="mdi mdi-clock-outline"></i>{{ 'HEADER.NOTIFICATIONS.THIRD.TIME' |
                      translate}}</p>
                  </div>
                </div>
              </div>
            </a>
            <a href="javascript: void(0);" class="text-reset notification-item">
              <div class="media">
                <img src="assets/images/users/avatar-4.jpg" class="me-3 rounded-circle avatar-xs" alt="user-pic">
                <div class="media-body">
                  <h6 class="mt-0 mb-1">{{ 'HEADER.NOTIFICATIONS.FOUR.TITLE' | translate}}</h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">{{ 'HEADER.NOTIFICATIONS.FOUR.TEXT' | translate}}</p>
                    <p class="mb-0"><i class="mdi mdi-clock-outline"></i>{{ 'HEADER.NOTIFICATIONS.FOUR.TIME' |
                      translate}}</p>
                  </div>
                </div>
              </div>
            </a>
          </ngx-simplebar>
          <div class="p-2 border-top d-grid">
            <a class="btn btn-sm btn-link font-size-14 text-center" href="javascript:void(0)">
              <i class="mdi mdi-arrow-right-circle me-1"></i> {{ 'HEADER.NOTIFICATIONS.LOAD_MORE' | translate}}
            </a>
          </div>
        </div>
      </div>

      <div class="dropdown d-inline-block" dropdown>
        <button type="button" class="btn header-item d-flex align-items-center" id="page-header-user-dropdown"
          dropdownToggle>
          <ng-container *ngIf="showLogoImage; else initialsBadgeHorizontal">
            <img class="rounded-circle header-profile-user" [src]="logoUrl" (error)="onLogoError()" alt="Logo">
          </ng-container>
          <ng-template #initialsBadgeHorizontal>
            <div class="rounded-circle header-avatar-initials">
              {{ userInitials }}
            </div>
          </ng-template>
          <span class="d-none d-xl-inline-block ms-2 font-size-13 fw-semibold text-truncate"
            style="max-width: 170px;">{{ getUserName }}</span>
          <i class="mdi mdi-chevron-down d-none d-xl-inline-block ms-1"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-end" *dropdownMenu>
          <a class="dropdown-item" href="javascript: void(0);"><i class="bx bx-user font-size-16 align-middle me-1"></i>
            {{ 'HEADER.LOGIN.PROFILE' | translate}}</a>
          <a class="dropdown-item" href="javascript: void(0);"><i
              class="bx bx-wallet font-size-16 align-middle me-1"></i>{{ 'HEADER.LOGIN.MY_WALLET' | translate}}</a>
          <a class="dropdown-item d-block" href="javascript: void(0);"><span
              class="badge bg-success float-end">11</span><i class="bx bx-wrench font-size-16 align-middle me-1"></i>{{
            'HEADER.LOGIN.SETTINGS' | translate}} </a>
          <a class="dropdown-item" href="javascript: void(0);"><i
              class="bx bx-lock-open font-size-16 align-middle me-1"></i>
            {{ 'HEADER.LOGIN.LOCK_SCREEN' | translate}}</a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item text-danger" href="javascript: void(0);" (click)="logout()"><i
              class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>
            {{ 'HEADER.LOGIN.LOGOUT' | translate}}</a>
        </div>
      </div>

      <div class="dropdown d-inline-block">
        <button type="button" class="btn header-item noti-icon right-bar-toggle" (click)="onSettingsButtonClicked()">
          <i class="bx bx-cog bx-spin"></i>
        </button>
      </div>
    </div>
  </div>

  <!-- ALERTAS EMERGENTES FLOTANTES (Stack de Toasts con Glassmorphism) -->
  @if (activeAlerts().length > 0) {
  <div class="floating-alerts-container" [class.position-bottom-right]="hasNonDismissibleAlert()">
    @for (alert of activeAlerts(); track alert.type) {
    <aside class="floating-alert-toast toast-level-{{ alert.level.toLowerCase() }} shadow-lg animate__animated"
      [class.animate__fadeInUp]="hasNonDismissibleAlert()"
      [class.animate__fadeInDown]="!hasNonDismissibleAlert()"
      role="alert" aria-live="polite">
      <div class="d-flex align-items-start gap-3">
        
        <!-- Icono contextual con pulso -->
        <div class="floating-toast-icon-box flex-shrink-0 d-flex align-items-center justify-content-center rounded-circle">
          @if (alert.type === 'DIGITAL_SIGNATURE') {
            <i class="fas fa-shield-alt font-size-18"></i>
          } @else if (alert.type === 'SIAT_TOKEN') {
            <i class="fas fa-key font-size-18"></i>
          } @else {
            <i class="fas fa-exclamation-circle font-size-18"></i>
          }
        </div>

        <!-- Contenido y mensaje -->
        <div class="flex-grow-1 min-w-0">
          <div class="d-flex align-items-center gap-2 mb-1.5 flex-wrap">
            <span class="floating-toast-title fw-bold font-size-13">
              @if (alert.type === 'DIGITAL_SIGNATURE') {
                Firma Digital SIAT
              } @else if (alert.type === 'SIAT_TOKEN') {
                Token Delegado SIAT
              } @else {
                Suscripción Clickbo
              }
            </span>
            <span class="badge rounded-pill font-size-10 fw-semibold floating-toast-badge">
              @if (alert.level === 'CRITICAL') {
                VENCIDO
              } @else if (alert.level === 'URGENT') {
                ¡VENCE EN {{ alert.daysRemaining }} {{ alert.daysRemaining === 1 ? 'DÍA' : 'DÍAS' }}!
              } @else {
                Vence en {{ alert.daysRemaining }} días
              }
            </span>
          </div>

          <p class="floating-toast-message mb-2.5 font-size-12">
            @if (alert.type === 'DIGITAL_SIGNATURE') {
              @if (alert.level === 'CRITICAL') {
                Tu Certificado Digital ha expirado. No es posible firmar ni emitir facturas electrónicas.
              } @else {
                Tu Firma Digital vence el <strong>{{ alert.expirationDate | date:'dd/MM/yyyy' }}</strong> (restan <strong>{{ alert.daysRemaining }} {{ alert.daysRemaining === 1 ? 'día' : 'días' }}</strong>). Tramita tu renovación ante ADSIB.
              }
            } @else if (alert.type === 'SIAT_TOKEN') {
              @if (alert.level === 'CRITICAL') {
                Tu Token Delegado SIAT ha expirado. La emisión de facturas electrónicas ante el SIN está pausada.
              } @else {
                Tu Token delegado vence el <strong>{{ alert.expirationDate | date:'dd/MM/yyyy' }}</strong> (restan <strong>{{ alert.daysRemaining }} {{ alert.daysRemaining === 1 ? 'día' : 'días' }}</strong>). Actualízalo ante el SIN para evitar cortes.
              }
            } @else {
              @if (alert.level === 'CRITICAL') {
                Tu suscripción está vencida. Regularízala para continuar emitiendo facturas.
              } @else {
                Tu plan vence el <strong>{{ alert.expirationDate | date:'dd/MM/yyyy' }}</strong> (restan <strong>{{ alert.daysRemaining }} días</strong>). Recuerda renovar a tiempo.
              }
            }
          </p>

          <!-- Botones de Acción -->
          <div class="d-flex align-items-center gap-2 flex-wrap">
            @if (alert.type === 'DIGITAL_SIGNATURE') {
              <a [href]="alert.whatsappUrl" target="_blank"
                class="btn btn-sm btn-success rounded-pill px-3 py-1 font-size-11 fw-semibold d-inline-flex align-items-center gap-1.5 shadow-sm"
                title="Asistencia por WhatsApp">
                <i class="bx bxl-whatsapp font-size-14"></i>
                <span>Renovar por WhatsApp</span>
              </a>
              <a routerLink="/profile/user"
                class="btn btn-sm btn-outline-secondary rounded-pill px-2.5 py-1 font-size-11 fw-semibold d-inline-flex align-items-center gap-1 shadow-sm"
                title="Ver Firma en Perfil">
                <i class="fas fa-user-cog font-size-11"></i>
                <span>Perfil</span>
              </a>
            } @else if (alert.type === 'SIAT_TOKEN') {
              <button type="button"
                class="btn btn-sm btn-primary rounded-pill px-3 py-1 font-size-11 fw-semibold d-inline-flex align-items-center gap-1.5 shadow-sm"
                (click)="openRefreshTokenModal()" title="Actualizar Token Delegado SIAT">
                <i class="fas fa-sync-alt font-size-11"></i>
                <span>Actualizar Token</span>
              </button>
              <a [href]="alert.whatsappUrl" target="_blank"
                class="btn btn-sm btn-success rounded-pill px-2.5 py-1 font-size-11 fw-semibold d-inline-flex align-items-center gap-1.5 shadow-sm"
                title="Asistencia por WhatsApp">
                <i class="bx bxl-whatsapp font-size-14"></i>
                <span>Ayuda</span>
              </a>
            } @else {
              <a [href]="alert.whatsappUrl" target="_blank"
                class="btn btn-sm btn-success rounded-pill px-3 py-1 font-size-11 fw-semibold d-inline-flex align-items-center gap-1.5 shadow-sm"
                [title]="alert.level === 'CRITICAL' ? 'Contactar a Ventas' : 'Renovar por WhatsApp'">
                <i class="bx bxl-whatsapp font-size-14"></i>
                <span>{{ alert.level === 'CRITICAL' ? 'Contactar a Ventas' : 'Renovar por WhatsApp' }}</span>
              </a>
            }
          </div>
        </div>

        <!-- Botón de Cierre Notorio y Táctil -->
        @if (alert.isDismissible) {
        <button type="button"
          class="btn floating-toast-close flex-shrink-0 d-flex align-items-center justify-content-center"
          (click)="closeAlert(alert.type)"
          aria-label="Cerrar aviso"
          title="Cerrar aviso">
          <i class="bx bx-x"></i>
        </button>
        }

      </div>
    </aside>
    }
  </div>
  }
</header>
<div class="topnav">
  <div class="container-fluid">
    <nav class="navbar navbar-light navbar-expand-lg topnav-menu active">
      <div class="collapse navbar-collapse active" id="topnav-menu-content">
        <ul class="navbar-nav">
          @for (item of menuItems(); track item) {
          <li class="nav-item dropdown">
            @if (!item.subItems) {
            <a class="nav-link dropdown-toggle arrow-none" href="javascript: void(0);" id="topnav-components"
              [routerLink]="item.link" role="button">
              <i class="bx {{item.icon}} me-2"></i>{{ item.label??'' | translate }} @if (hasItems(item)) {
              <div class="arrow-down"></div>
              }
            </a>
            }
            @if (item.subItems) {
            <a class="nav-link dropdown-toggle arrow-none" (click)="onMenuClick($event)" href="javascript: void(0);"
              id="topnav-components" role="button">
              <i class="bx {{item.icon}} me-1"></i>
              {{item.label??''| translate }}
              <div class="arrow-down"></div>
            </a>
            }
            @if (hasItems(item)) {
            <div class="dropdown-menu" [ngClass]="{'dropdown-mega-menu-xl px-2':  item.subItems.length > 11}"
              aria-labelledby="topnav-dashboard">
              @for (subitem of item.subItems; track subitem; let i = $index) {
              @if (item.subItems.length < 11 && !hasItems(subitem)) { <a class="col dropdown-item side-nav-link-ref"
                [routerLink]="subitem.link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                {{subitem.label | translate }}
                </a>
                }
                @if (item.subItems.length > 11) {
                <div>
                  @if (i % 3 == 0) {
                  <div class="row">
                    <div class="col-lg-4"><a class="dropdown-item side-nav-link-ref" routerLinkActive="active"
                        [routerLink]="subitem.link">{{item.subItems[i].label | translate}}</a></div>
                    <div class="col-lg-4"><a class="dropdown-item side-nav-link-ref" routerLinkActive="active"
                        [routerLink]="item.subItems[i + 1]?.link">{{item.subItems[i + 1]?.label | translate}}</a></div>
                    <div class="col-lg-4"><a class="dropdown-item side-nav-link-ref" routerLinkActive="active"
                        [routerLink]="item.subItems[i + 2]?.link">{{item.subItems[i + 2]?.label | translate}}</a></div>
                  </div>
                  }
                </div>
                }
                @if (item.subItems.length == 11 && !hasItems(subitem)) {
                <div>
                  <a class="dropdown-item dropdown-toggle" href="javascript: void(0);" (click)="onMenuClick($event)">{{
                    subitem.label | translate }}
                    <div class="arrow-down"></div>
                  </a>
                </div>
                }
                @if (hasItems(subitem)) {
                <div class="dropdown">
                  <a class="dropdown-item dropdown-toggle" href="javascript: void(0);" (click)="onMenuClick($event)">{{
                    subitem.label | translate }}
                    <div class="arrow-down"></div>
                  </a>
                  <div class="dropdown-menu">
                    @for (subSubitem of subitem.subItems; track subSubitem) {
                    @if (!hasItems(subSubitem)) {
                    <a class="dropdown-item side-nav-link-ref" href="javascript: void(0);"
                      [routerLink]="subSubitem.link" routerLinkActive="active">{{ subSubitem.label | translate }}</a>
                    }
                    @if (hasItems(subSubitem)) {
                    <div class="dropdown">
                      <a class="dropdown-item dropdown-toggle" href="javascript: void(0);"
                        (click)="onMenuClick($event)">{{ subSubitem.label | translate }}
                        <div class="arrow-down"></div>
                      </a>
                      <div class="dropdown-menu">
                        @for (subSubSubitem of subSubitem.subItems; track subSubSubitem) {
                        <a class="dropdown-item side-nav-link-ref" href="javascript: void(0);"
                          [routerLink]="subSubSubitem.link" routerLinkActive="active">{{ subSubSubitem.label | translate
                          }}</a>
                        }
                      </div>
                    </div>
                    }
                    }
                  </div>
                </div>
                }
                }
            </div>
            }
          </li>
          }
        </ul>
      </div>
    </nav>
  </div>
</div>